var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        [
          _c("v-toolbar-title", [
            _c("div", [
              _c(
                "div",
                { staticClass: "info--text" },
                [
                  _c("v-icon", { attrs: { medium: "" } }, [_vm._v("router")]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Vegetative Monitoring")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "body-2" }, [
                _vm._v("\n          Summary\n        "),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm.wideForm
        ? _c(
            "v-card",
            { staticClass: "card-bg-4" },
            [
              _c("PlotDataSourceSurveySummary", {
                staticClass: "mb-2",
                attrs: {
                  "data-ui-component": "Survey Summary",
                  dataSource: _vm.vegetativePlotDataSource,
                },
              }),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { staticClass: "pr-1", attrs: { xs6: "" } },
                    [
                      _c("PlotDataSourceInformationTable", {
                        attrs: {
                          "data-ui-component": "Plot Metadata",
                          editForm: _vm.editForm,
                          dataSource: _vm.vegetativePlotDataSource,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "pl-1",
                      attrs: {
                        xs6: "",
                        "data-ui-component": "Aliases and Plot Hierarchy",
                      },
                    },
                    [
                      _c("PlotDataSourceSpecimenaSummary", {
                        staticClass: "mb-1",
                        attrs: {
                          "data-ui-component": "Specimen Count",
                          dataSource: _vm.vegetativePlotDataSource,
                        },
                      }),
                      _vm._v(" "),
                      _c("PlotAliases", {
                        attrs: {
                          "data-ui-component": "Aliases",
                          editForm: _vm.editForm,
                          dataSourceIndex: _vm.vegetativePlotDataSourceIndex,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-card",
            { staticClass: "card-bg-4" },
            [
              _c("PlotDataSourceSurveySummary", {
                staticClass: "mb-2",
                attrs: { dataSource: _vm.vegetativePlotDataSource },
              }),
              _vm._v(" "),
              _c("PlotDataSourceSpecimenaSummary", {
                staticClass: "mb-2",
                attrs: { dataSource: _vm.vegetativePlotDataSource },
              }),
              _vm._v(" "),
              _c("PlotDataSourceInformationTable", {
                staticClass: "mb-2",
                attrs: {
                  editForm: _vm.editForm,
                  dataSource: _vm.vegetativePlotDataSource,
                },
              }),
              _vm._v(" "),
              _c("PlotAliases", {
                attrs: {
                  editForm: _vm.editForm,
                  dataSourceIndex: _vm.vegetativePlotDataSourceIndex,
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }